import React from 'react';
import { classnames } from '../../utils';

import styles from './Switch.module.scss';

/**
 * Switch/toggle component (renders as `<input type="checkbox">`).
 *
 * @type {React.FC<InputProps>}
 * @typedef InputProps
 * @property {string} [className] Optional class to apply to the container
 *
 * @param {React.InputHTMLAttributes<HTMLInputElement> & InputProps} props
 *
 * @returns React.JSX.Element
 */
const Switch = ({ className = '', ...props }) => {
	return (
		<label className={classnames(styles.switch, className)}>
			<input type="checkbox" {...props} />
			<span className={styles.slider} />
		</label>
	);
};

export default Switch;
